import type { DeleteAppetitesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

const mapTrpcResponseToGraphQL = (): DeleteAppetitesMutation => {
  return {
    delete_appetite: {
      __typename: 'appetite_mutation_response',
      affected_rows: 1,
    },
  };
};

export const useDeleteAppetitesTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.appetite.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.appetite.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.appetite.getById.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.appetite.appetitesByRiskId.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.appetite.activeAppetitesByParentId.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey:
            trpc.frontend.appetite.getAppetitesGroupedByImpact.queryKey(),
        });
        // COI-471 parity: Apollo twin evicts the `risk` field (appetites
        // surface on the linked risk).
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.risk.pathKey(),
        });
      },
    }),
  });

  return {
    deleteAppetites: async (variables: {
      ids: string[];
    }): Promise<DeleteAppetitesMutation> => {
      await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL();
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
